module.exports = __webpack_public_path__ + "img/tile-oil2.ccf0fbfe.jpg";